module.exports = __webpack_public_path__ + "static/Calendar Circle-8cb3b54e7d6e400059cd5bbd7e062a1a.png";